import { render } from "./UserDetailsContainer.vue?vue&type=template&id=a78deabc"
import script from "./UserDetailsContainer.vue?vue&type=script&lang=js"
export * from "./UserDetailsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__